const NEW_READINGS = 'NEW_READING';
const ACTIVE_ALARM_CHANGE = 'ACTIVE_ALARM_CHANGE';

export { NEW_READINGS, ACTIVE_ALARM_CHANGE };
